import { billingConstants } from '../_constants';

const initialState = {
  invoices: [],
  payments: [],
  errors: {}
};

export function billing(state = initialState, action) {
  switch (action.type) {

  case billingConstants.INVOICE_OPTIONS_LOADED:
    return Object.assign({}, state, { options: action.data.actions.POST });

  case billingConstants.INVOICES_LOADED:
    return Object.assign({}, state, { invoices: action.data.results});

  case billingConstants.INVOICE_CREATED:
    let { invoices } = state;
    invoices.unshift(action.data);
    return Object.assign({}, state, { invoices, message: 'Invoice successfully created.' });

  case billingConstants.INVOICE_LOADED:
    return Object.assign({}, state, { invoice: action.data});

  case billingConstants.INVOICE_UPDATED:
    invoices = state.invoices.slice();
    let idx = invoices.findIndex(item => item.id === action.data.id);
    invoices[idx] = action.data;
    return Object.assign({}, state, { invoices, message: 'Invoice successfully updated.' });

  case billingConstants.INVOICE_ERRORS:
    return Object.assign({}, state, { errors: action.errors });

  case billingConstants.INVOICE_DELETED:
    invoices = [ ...state.invoice ];
    idx = invoices.findIndex(item => item.id === action.data.id);
    if (idx) {
      delete invoices[idx];
    }
    return Object.assign({}, state, { invoices: [ ...invoices ], message: 'Invoice successfully deleted.' });

  case billingConstants.INVOICE_RESET:
    return Object.assign({}, state, { message: '', errors: {} });


  case billingConstants.PAYMENT_OPTIONS_LOADED:
    return Object.assign({}, state, { options: action.data.actions.POST });

  case billingConstants.PAYMENTS_LOADED:
    return Object.assign({}, state, { payments: action.data.results});

  case billingConstants.PAYMENT_CREATED:
    let { payments } = state;
    payments.unshift(action.data);
    return Object.assign({}, state, { payments, message: 'Payment successfully created.' });

  case billingConstants.PAYMENT_LOADED:
    return Object.assign({}, state, { payment: action.data});

  case billingConstants.PAYMENT_UPDATED:
    payments = state.payments.slice();
    idx = payments.findIndex(item => item.id === action.data.id);
    payments[idx] = action.data;
    return Object.assign({}, state, { payments, message: 'Payment successfully updated.' });

  case billingConstants.PAYMENT_ERRORS:
    return Object.assign({}, state, { errors: action.errors });

  case billingConstants.PAYMENT_DELETED:
    payments = state;
    idx = payments.findIndex(item => item.id === action.data.id);
    delete payments[idx];
    return Object.assign({}, state, { payments, message: 'Payment successfully deleted.' });

  case billingConstants.PAYMENT_RESET:
    return Object.assign({}, state, { message: '', errors: {} });

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/billing.reducer.js